import api from '../api';
import { fetchLogin } from './login'

//default state
export const DEFAULT_STATE = {
    isLoading: false,
    error: null,
    allUsers: [],
    userById: {},
    isUserUpdated: false,
    groups: [],
};

export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';
export const REMIND_PASSWORD = 'REMIND_PASSWORD';
export const REMIND_PASSWORD_SUCCESS = 'REMIND_PASSWORD_SUCCESS';
export const REMIND_PASSWORD_FAILURE = 'REMIND_PASSWORD_FAILURE';

export const UPDATE_USER_BY_ID = 'UPDATE_USER_BY_ID';
export const UPDATE_USER_BY_ID_SUCCESS = 'UPDATE_USER_BY_ID_SUCCESS';
export const UPDATE_USER_BY_ID_FAILURE = 'UPDATE_USER_BY_ID_FAILURE';
export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';
export const GET_USER_BY_ID_FAILURE = 'GET_USER_BY_ID_FAILURE';

export const GET_USERS = 'GET_ALL_USERS';
export const GET_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_ALL_USERS_FAILURE';

export const DELETE_USER_BY_ID = 'DELETE_USER_BY_ID';
export const DELETE_USER_BY_ID_SUCCESS = 'DELETE_USER_BY_ID_SUCCESS';
export const DELETE_USER_BY_ID_FAILURE = 'DELETE_USER_BY_ID_FAILURE';

//selectors
export const getIsUserLoading = (state) => state && state.user && state.user.isLoading;
export const getAllUsers = (state) => state && state.user && state.user.allUsers;
export const getIsEmailSent = (state) => state && state.user.isEmailSent;
export const getUserById = (state) => state && state.user && state.user.userById;
export const getIsUserUpdated = (state) => state && state.user && state.user.isUserUpdated;
export const getError = (state) => state && state.user && state.user.error;

//actions
export const fetchCreateUser = (userInfo) => (dispatch, state) => {
    dispatch({
        type: CREATE_USER
    })
    api.createUser(userInfo)
        .then(res => {
            dispatch({
                type: CREATE_USER_SUCCESS,
            })
            dispatch(fetchLogin(userInfo));
        })
        .catch(err => dispatch({
            type: CREATE_USER_FAILURE,
            payload: err.response.data.error
        }))
}

export const fetchAllUsers = () => (dispatch, state) => {
    dispatch({
        type: GET_USERS
    })
    api.getAllUsers()
        .then((res) => {
            dispatch({
                type: GET_USERS_SUCCESS,
                payload: res.data.map(el => ({ ...el, id: el._id }))
            })
        })
        .catch(err => dispatch({
            type: GET_USERS_FAILURE,
            payload: err.error
        }))
}

export const fetchNewUsers = () => (dispatch, state) => {
    dispatch({
        type: GET_USERS
    })
    api.getNewUsers()
        .then((res) => {
            dispatch({
                type: GET_USERS_SUCCESS,
                payload: res.data.map(el => ({ ...el, id: el._id }))
            })
        })
        .catch(err => dispatch({
            type: GET_USERS_FAILURE,
            payload: err.error
        }))
}

export const sentRemindPassword = (email) => (dispatch, state) => {
    dispatch({
        type: REMIND_PASSWORD
    })

    api.remindPassword(email)
        .then(res => {
            dispatch({
                type: REMIND_PASSWORD_SUCCESS,
            })
        })
        .catch(err => dispatch({
            type: REMIND_PASSWORD_FAILURE,
            payload: err.response.data.error
        }))
}

export const fetchUserById = (userId) => (dispatch, state) => {
    dispatch({
        type: GET_USER_BY_ID
    })
    api.getUserById(userId)
        .then(res => {
            dispatch({
                type: GET_USER_BY_ID_SUCCESS,
                payload: res.data
            })
        })
        .catch(err => {
            dispatch({
                type: GET_USER_BY_ID_FAILURE,
                payload: err
            })
        })
}
export const patchUserById = (userInfo) => (dispatch, state) => {
    dispatch({
        type: UPDATE_USER_BY_ID
    })
    api.patchUserById(userInfo)
        .then(res => {
            dispatch({
                type: UPDATE_USER_BY_ID_SUCCESS,
            })
        })
        .catch(err => {
            dispatch({
                type: UPDATE_USER_BY_ID_FAILURE,
                payload: err.response.data.error
            })
        })
}

export const deleteUserById = (userId) => (dispatch, state) => {
    dispatch({
        type: DELETE_USER_BY_ID
    })
    api.deleteUserByIdApi(userId)
        .then(() => {
            dispatch({
                type: DELETE_USER_BY_ID_SUCCESS,
            })
            dispatch(fetchAllUsers())
        })
        .catch(err => {
            dispatch({
                type: DELETE_USER_BY_ID_FAILURE,
                payload: err
            })
        })
}

//reducer
// eslint-disable-next-line
export default function (state = DEFAULT_STATE, action) {
    const { type, payload } = action;

    switch (type) {
        case CREATE_USER:
            return { ...state, isLoading: true, error: null }
        case CREATE_USER_SUCCESS:
            return { ...state, isLoading: false, error: null }
        case CREATE_USER_FAILURE:
            return { ...state, isLoading: false, error: payload }

        case UPDATE_USER_BY_ID:
            return { ...state, isLoading: true, error: null, isUserUpdated: false }
        case UPDATE_USER_BY_ID_SUCCESS:
            return { ...state, isLoading: false, error: null, isUserUpdated: true }
        case UPDATE_USER_BY_ID_FAILURE:
            return { ...state, isLoading: false, error: payload }

        case GET_USER_BY_ID:
            return { ...state, isLoading: true, error: null, isUserUpdated: false, userById: {} }
        case GET_USER_BY_ID_SUCCESS:
            return { ...state, isLoading: false, error: null, userById: payload }
        case GET_USER_BY_ID_FAILURE:
            return { ...state, isLoading: false, error: payload }

        case DELETE_USER_BY_ID:
            return { ...state, isLoading: true, error: null }
        case DELETE_USER_BY_ID_SUCCESS:
            return { ...state, isLoading: false, error: null }
        case DELETE_USER_BY_ID_FAILURE:
            return { ...state, isLoading: false, error: payload }

        case GET_USERS:
            return { ...state, isLoading: true, error: null }
        case GET_USERS_SUCCESS:
            return { ...state, isLoading: false, error: null, allUsers: payload }
        case GET_USERS_FAILURE:
            return { ...state, isLoading: false, error: payload }
        case REMIND_PASSWORD:
            return { ...state, isLoading: true, error: null, isEmailSent: false }
        case REMIND_PASSWORD_SUCCESS:
            return { ...state, isLoading: false, error: null, isEmailSent: true, message: payload }
        case REMIND_PASSWORD_FAILURE:
            return { ...state, isLoading: false, error: payload }
        default:
            return state;
    }
}